export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST'
export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS'
export const SUBSCRIPTION_FAILURE = 'SUBSCRIPTION_FAILURE'
